import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-dialog-upload-and-cropping',
  templateUrl: './dialog-upload-and-cropping.component.html',
  styleUrls: ['./dialog-upload-and-cropping.component.scss'],
})
export class DialogUploadAndCroppingComponent implements OnInit {
  isDragging: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogUploadAndCroppingComponent>,
    private _toaster: ToastrService,
    private _translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  imageChangedEvent: any = '';
  croppedImage: any = '';

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];

    //check it opened from file management
    if (this.data.acceptPdf) {
      this.dialogRef.close(file);
    } else {
      this.imageChangedEvent = event;
    }
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
  }

  imageLoaded(image: LoadedImage = null): void {
    // show cropper
  }

  cropperReady(): void {
    // cropper ready
  }

  loadImageFailed(): void {
    // show message
  }

  onHandleFileInput(files: FileList): void {
    //
    //   this.filesList.emit([...this.displayedFiles, ...this.uploadedFiles]);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const files = event.dataTransfer?.files;

    if (files && files.length > 1) {
      this._toaster.warning(this._translocoService.translate('You can upload one file only.'));
    } else {
      //get file type
      const file = files[0];
      const isImage = file.type.startsWith('image/');
      const isPdf = file.type === 'application/pdf';
      const isSupported = isImage || isPdf;

      if (isSupported) {
        //check if opened from floor management
        if (this.data.acceptPdf) {
          this.dialogRef.close(file);
        } else {
          isPdf
            ? this._toaster.error(
                this._translocoService.translate('You can upload image file only.'),
              )
            : (this.imageChangedEvent = { target: { files: [files[0]] } } as any);
        }
      } else {
        this._toaster.error(
          this._translocoService.translate(
            this.data.acceptPdf
              ? 'File can be of type JPEG/PNG or PDF only'
              : 'You can upload image file only.',
          ),
        );
      }
    }
  }
}
